import React, { useState, useEffect } from 'react';
import './navigation.css';
import Logo from '../logo/Plevel_design_horizontal.png';

function Navigation() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const close = () => setOpen(false);

    // Sleduj scroll — když uživatel přejede hero, navigace se "ukotví":
    // objeví se plné logo, přidá se stín a pevné pozadí. Nad hero je nav
    // průhledná (frosted-glass), aby velké logo v hero dýchalo samo.
    useEffect(() => {
        const onScroll = () => {
            const threshold = Math.min(window.innerHeight * 0.75, 380);
            setScrolled(window.scrollY > threshold);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <nav
            className={`navigation ${scrolled ? 'is-scrolled' : ''}`}
            aria-label="Hlavní navigace"
        >
            <a
                href="#hero"
                className="nav-logo"
                onClick={close}
                aria-label="Plevel design — domů"
                aria-hidden={!scrolled}
                tabIndex={scrolled ? 0 : -1}
            >
                <img src={Logo} alt="Plevel design" />
            </a>

            <button
                className="nav-burger"
                aria-label={open ? 'Zavřít menu' : 'Otevřít menu'}
                aria-expanded={open}
                onClick={() => setOpen((o) => !o)}
            >
                <span />
                <span />
                <span />
            </button>

            <ul className={`nav-list ${open ? 'is-open' : ''}`}>
                <li><a href="#O mně" onClick={close}>O mně</a></li>
                <li><a href="#Vybrané projekty" onClick={close}>Projekty</a></li>
                <li><a href="#Služby Ceník" onClick={close}>Služby</a></li>
                <li><a href="#Portfolio" onClick={close}>Portfolio</a></li>
                <li><a href="#Reference" onClick={close}>Reference</a></li>
                <li className="nav-cta">
                    <a href="#Kontakt" className="cta-button" onClick={close}>
                        Sjednat konzultaci
                    </a>
                </li>
            </ul>
        </nav>
    );
}

export default Navigation;
